import request from '@/utils/request'




/**
 * 设备概览
 */
export function getOverview() {
  return request({
    url: '/dashboard/v3/station/monitoring/queryOverview',
    method: 'get',    
  })
}



/**
 * 电站总览
 * @param {Object} params - 请求参数
 * @param {string} params.pageSize - 分页大小
 * @param {string} params.pageNum - 分页页码
 */
export function getStationMonitorList(params) {
  return request({
    url: '/dashboard/v3/station/monitoring/queryList',
    method: 'get',    
    params
  })
}
